import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterExpensesView.
 * @extends JetView
 */
export default class FilterExpensesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the filter form
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for Consecutive
                            name: 'Consecutive',
                            type: 'text',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Consecutivo'),
                            labelPosition: 'top',
                            placeholder: _('Consecutivo'),
                        },
                        {
                            view: 'text', // Readonly text input for Datepicker
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker', // Datepicker for selecting dates
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'radio', // Radio buttons for Credit Cards option
                            name: 'CreditCards',
                            label: _('Tarjeta de crédito'),
                            labelPosition: 'top',
                            value: 0,
                            options: [
                                { id: 0, value: _('Sí') },
                                { id: 1, value: _('No') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Upper section of the form
        const left2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'TypeEgress',
                    id: 'TypeEgressFilter',
                    label: _('Tipo de Egreso'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'text',
                    name: 'DocumentID',
                    type: 'number',
                    label: _('Documento ID'),
                    labelPosition: 'top',
                    placeholder: _('Documento ID'),
                },
            ],
        };

        // Upper section of the form
        const center_left2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'BetShop',
                    id: 'BetShopFilter',
                    label: "<span class='icon-shop'></span>" + _('Punto de Venta'),
                    hidden: !devConfig.getPermAction('filterByBetShop', 'Add'),
                    css: 'prm-filterByBetShop',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'richselect',
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: _('Todos') },
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
            ],
        };

        // Upper section of the form
        const center_right2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'CostCenter',
                    id: 'CostCenterFilter',
                    label: _('Centro de Costos'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Upper section of the form
        const right2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'Concepts',
                    id: 'ConceptsFilter',
                    label: _('Concepto'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Upper section of the form
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 180 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 360 : 0,
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left2, center_left2, center_right2, right2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Including upper_section2
                            },
                        },
                    ],
                },
            ],
        };

        // Button section with actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if applicable
                                    }
                                }
                                this.app.callEvent('expense:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, accordion_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen is small
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if not applicable
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if applicable
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });

        // AJAX calls to fetch filter options
        webix
            .ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', '{"Type":2}', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error handling
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    $$('TypeEgressFilter').define('options', resp.Data); // Set options for TypeEgressFilter
                    $$('TypeEgressFilter').refresh(); // Refresh the filter
                },
            });

        // Additional AJAX calls for other filters
        webix
            .ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(devConfig.geturlApi() + 'Accounting/GetBetShopSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error handling
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    $$('BetShopFilter').define('options', resp.Data); // Set options for BetShopFilter
                    $$('BetShopFilter').refresh(); // Refresh the filter
                },
            });

        webix
            .ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(devConfig.geturlApi() + 'Accounting/GetCostCenterSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error handling
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    $$('CostCenterFilter').define('options', resp.Data); // Set options for CostCenterFilter
                    $$('CostCenterFilter').refresh(); // Refresh the filter
                },
            });

        webix
            .ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error handling
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    $$('ConceptsFilter').define('options', resp.Data); // Set options for ConceptsFilter
                    $$('ConceptsFilter').refresh(); // Refresh the filter
                },
            });
    }
}

// FILE DOCUMENTED
